module.exports = "/_next/static/images/d201e9af7c5aebef0f9aa392e84c786f-cuenta-cards-xs.png";